import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import siteConfig from '@/config';
import PATH_PAGE from '@/router/path';
import { WORKSPACE_STATUS } from '@/service/workspace/constants';
import { useGetWorkspaces } from '@/service/workspace/hook';
import { fDate } from '@/utils/formatTime';
import { ChevronRightIcon, PlusIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';

const Workspaces = () => {
  const { data } = useGetWorkspaces();
  return (
    <>
      <div className="container flex flex-col gap-3">
        <p className="text-xl font-semibold">All Workspace</p>
        <div className="flex justify-end gap-4">
          {siteConfig.services.workspace?.create && (
            <Link to={PATH_PAGE.dashboard.newWorkspace}>
              <Button size={'sm'} startIcon={<PlusIcon />}>
                New Workspace
              </Button>
            </Link>
          )}
        </div>
        <div className="mt-2 grid gap-4 sm:grid-cols-2">
          {data?.map((workspace) => (
            <Link
              key={workspace.workspace_id}
              to={PATH_PAGE.dashboard.workspaceById(workspace.workspace_id!)}
            >
              <Card className="cursor-pointer p-4 hover:bg-muted">
                <div className="flex items-center justify-between">
                  <div className="font-medium">
                    {workspace.workspace_name}
                    {workspace.workspace_status ===
                      WORKSPACE_STATUS.DEFAULT && (
                      <span className="pl-2 opacity-50">default</span>
                    )}
                  </div>
                  <ChevronRightIcon />
                </div>
                <div className="mt-1 flex flex-col gap-1 text-xs">
                  <span>
                    Create Date:{' '}
                    {workspace.create_date ? fDate(workspace.create_date) : ''}
                  </span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default Workspaces;
